export const TRACKS = {
  ADULT: 'adult',
  YOUTH: 'youth',
};

// White-belt level per track — the baseline level assumed when a user's
// belt is missing or doesn't match their current track.
export const WHITE_BELT_LEVEL_BY_TRACK = {
  [TRACKS.ADULT]: 0,
  [TRACKS.YOUTH]: -3,
};

export function normalizeTrack(track) {
  return track === TRACKS.YOUTH ? TRACKS.YOUTH : TRACKS.ADULT;
}

export function getWhiteBeltLevelForTrack(track) {
  return WHITE_BELT_LEVEL_BY_TRACK[normalizeTrack(track)];
}

export function isYouthBelt(belt) {
  return belt.level < 0;
}

export function getBeltsForTrack(belts, track) {
  const youth = normalizeTrack(track) === TRACKS.YOUTH;
  return belts.filter((belt) => (youth ? belt.level < 0 : belt.level >= 0));
}

export function getDrillIdsForTrack(belts, track) {
  const ids = new Set();
  getBeltsForTrack(belts, track).forEach((belt) => {
    belt.drillIds.forEach((id) => ids.add(id));
  });
  return ids;
}

export function getDefaultBeltForTrack(track) {
  return normalizeTrack(track) === TRACKS.YOUTH ? 'white-belt-youth' : 'white-belt';
}
